import { getParent } from "mobx-keystone";
import React from "react";
import { DynamicMapElementAnimationElementModel } from "../../shared/game/dynamicMapElements/DynamicMapElementAnimationElementModel";
import { DynamicMapElementAreaTriggerModel } from "../../shared/game/dynamicMapElements/DynamicMapElementAreaTriggerModel";
import { DynamicMapElementMapMarkerModel } from "../../shared/game/dynamicMapElements/DynamicMapElementMapMarkerModel";
import { DynamicMapElementNPCModel } from "../../shared/game/dynamicMapElements/DynamicMapElementNPCModel";
import { TileDataInteractionTriggerModel } from "../../shared/game/TileDataInteractionTriggerModel";
import { TileDataModel } from "../../shared/game/TileDataModel";
import { ViewAreaTriggerModel } from "../../shared/game/ViewAreaTriggerModel";
import { TileImageUsage } from "../../shared/resources/TileAssetModel";
import { loadingAnimationUrl } from "../canvas/loader/StaticAssetLoader";
import { ElementIconType, ElementIconMapMarker, ElementIconAreaTrigger, ElementIconViewAreaTrigger, ElementIconStartMarker, ElementIconTile, ElementAnimation, ElementCharacter } from "../components/editor/ElementIcons";
import { gameConstants } from "../data/gameConstants";
import { animationThumbnailStore, characterThumbnailStore } from "../stores/GeneratedThumbnailStore";
import { sharedStore } from "../stores/SharedStore";
import { tileImageStore } from "../stores/TileImageStore";
export function getImageForElement(element) {
  var _sharedStore$getAnima;

  if (element instanceof DynamicMapElementNPCModel) return characterThumbnailStore.getOrGenerateThumbnail(element.characterId) || loadingAnimationUrl;
  if (element instanceof DynamicMapElementAnimationElementModel) return animationThumbnailStore.getOrGenerateThumbnail((_sharedStore$getAnima = sharedStore.getAnimationByName(element.animationName)) === null || _sharedStore$getAnima === void 0 ? void 0 : _sharedStore$getAnima.id) || loadingAnimationUrl;

  if (element instanceof TileDataInteractionTriggerModel) {
    // Get TileDataModel
    element = getParent(element);
  }

  if (element instanceof TileDataModel) {
    return tileImageStore.thumbnailUrl(element.tileAssetId, TileImageUsage.Background);
  }

  return null;
}
export function getIconForElement(element) {
  if (element instanceof DynamicMapElementNPCModel) return null;

  if (element instanceof DynamicMapElementMapMarkerModel) {
    if (element.label === gameConstants.mapStartMarker) {
      return /*#__PURE__*/React.createElement(ElementIconStartMarker, {
        type: ElementIconType.ActionEditorSelector
      });
    } else {
      return /*#__PURE__*/React.createElement(ElementIconMapMarker, {
        type: ElementIconType.ActionEditorSelector
      });
    }
  }

  if (element instanceof DynamicMapElementAreaTriggerModel) return /*#__PURE__*/React.createElement(ElementIconAreaTrigger, {
    type: ElementIconType.ActionEditorSelector
  });
  if (element instanceof DynamicMapElementAnimationElementModel) return null;
  if (element instanceof TileDataModel || element instanceof TileDataInteractionTriggerModel) return null;
  if (element instanceof ViewAreaTriggerModel) return /*#__PURE__*/React.createElement(ElementIconViewAreaTrigger, null);
  console.log("Couldn't find icon for element", element);
  return null;
}
export function getIconForElementPartOfText(element) {
  if (element instanceof DynamicMapElementNPCModel) return /*#__PURE__*/React.createElement(ElementCharacter, {
    type: ElementIconType.PartOfText
  });

  if (element instanceof DynamicMapElementMapMarkerModel) {
    if (element.label === gameConstants.mapStartMarker) {
      return /*#__PURE__*/React.createElement(ElementIconStartMarker, {
        type: ElementIconType.PartOfText
      });
    } else {
      return /*#__PURE__*/React.createElement(ElementIconMapMarker, {
        type: ElementIconType.PartOfText
      });
    }
  }

  if (element instanceof DynamicMapElementAreaTriggerModel) return /*#__PURE__*/React.createElement(ElementIconAreaTrigger, {
    type: ElementIconType.PartOfText
  });
  if (element instanceof DynamicMapElementAnimationElementModel) return /*#__PURE__*/React.createElement(ElementAnimation, {
    type: ElementIconType.PartOfText
  });
  if (element instanceof TileDataModel || element instanceof TileDataInteractionTriggerModel) return /*#__PURE__*/React.createElement(ElementIconTile, {
    type: ElementIconType.PartOfText
  });
  console.log("Couldn't find icon for element", element);
  return null;
}